import React from "react";
import dynamic from "next/dynamic";
import { useAppContext } from "@components/Provider";

import "./EBBHomepage.css";

const ContentHome = dynamic(() => import("./ContentHome"));

const EBBHomepage = (props) => {
  const { subscriberCookie } = useAppContext();
  let copyProps = { ...props };
  copyProps.data[0].Index = copyProps.data[0].Post;

  return (
    <>
      <ContentHome
        HomeData={copyProps}
        vars={{
          "--newsLettetPb-768-top": subscriberCookie ? "15%" : "20%",
          "--newsLettetPb-667-top": subscriberCookie ? "12%" : "20%",
          "--newsLettetPb-667-l-top": subscriberCookie ? "12%" : "40%",
          "--newsLettetPb-812-top": subscriberCookie ? "12%" : "16%",
          "--newsLettetPb-812-l-top": subscriberCookie ? "12%" : "30%",
          "--newsLettetPb-767-top": subscriberCookie ? "12%" : "20%",
        }}
      />
    </>
  );
};

export default EBBHomepage;
